import React from "react"
import { Container, LowerContainer } from "./ContactCard.styles"
import { Icon } from "../Icon/Icon"
import PropTypes from "prop-types"

export const ContactCard = ({
  name,
  email,
  email2,
  phone,
  phone2,
  hours,
  physicalAddress,
  physicalAddress2,
  customComment,
  moreInfo,
}) => {
  return (
    <>
      <Container style={{ width: `100%` }}>
        <span className="primaryLabel whiteTxt">Contact Information</span>
      </Container>
      <LowerContainer style={{ width: `100%` }}>
        <span className="headline">{name}</span>
        <br />
        {phone && phone.length > 0 ? (
          <div>
            <Icon width="20px" className="imgMargin" category="Phone"></Icon>
            <a href={"tel:" + phone} className="primaryLink darkBlueTxt">
              {phone}
            </a>
            <br />
          </div>
        ) : null}
        {phone2 && phone2.length > 0 ? (
          <div>
            <Icon width="20px" className="imgMargin" category="Phone"></Icon>
            <a href={"tel:" + phone2} className="primaryLink darkBlueTxt">
              {phone2}
            </a>
            <br />
          </div>
        ) : null}
        <Icon alt="" width="24px" className="imgMargin" category="Email"></Icon>
        <a href={"mailto:" + email} className="primaryLink darkBlueTxt">
          {email}
        </a>
        {email2 && email2.length > 0 ? (
          <div>
            <Icon width="20px" className="imgMargin" category="Email"></Icon>
            <a href={"mailto:" + email2} className="primaryLink darkBlueTxt">
              {email2}
            </a>
            <br />
          </div>
        ) : null}
        {hours && hours.length > 0 ? (
          <div>
            <Icon width="20px" className="imgMargin" category="Clock"></Icon>
            <span className="primaryLink darkBlueTxt">{hours}</span>
            <br />
          </div>
        ) : null}
        {physicalAddress && physicalAddress.length > 0 ? (
          <div>
            <Icon width="20px" className="imgMargin" category="Building"></Icon>
            <span className="primaryLink darkBlueTxt">{physicalAddress}</span>
            <br />
          </div>
        ) : null}
        {physicalAddress2 && physicalAddress2.length > 0 ? (
          <div>
            <Icon width="20px" className="imgMargin" category="Building"></Icon>
            <span className="primaryLink darkBlueTxt">{physicalAddress2}</span>
            <br />
          </div>
        ) : null}
        {customComment && customComment.length > 0 ? (
          <div>
            <p className="paragraphSmall darkBlueTxt">{customComment}</p>
            <br />
          </div>
        ) : null}
        <br />
        {moreInfo ? <p className="paragraphSmall">{moreInfo}</p> : null}
      </LowerContainer>
    </>
  )
}

ContactCard.propTypes = {
  width: PropTypes.string,
  name: PropTypes.string.isRequired,
  provider: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  email2: PropTypes.string,
  phone: PropTypes.string,
  phone2: PropTypes.string,
  hours: PropTypes.string,
  physicalAddress: PropTypes.string,
  physicalAddress2: PropTypes.string,
  customComment: PropTypes.string,
  moreInfo: PropTypes.string,
}

export default ContactCard
